import React, { useEffect, useState } from 'react'
import { Button, Modal } from '../../../../components'
import { LiteralsService } from '../../../../services'
import StyledSection from './styles'
import Calendar, { CalendarTileProperties } from 'react-calendar'
import moment from 'moment'
import { IWeekday } from '../../../../models/weekday'

interface IProps {
  visible: boolean
  selectedDay: Date
  availableDates: IWeekday[]
  onSave: (date: Date) => any
  close: () => void
}

export const CalendarModal: React.FC<IProps> = ({ visible, selectedDay, availableDates, onSave, close }) => {
  const [markedDate, setMarkedDay] = useState(new Date(selectedDay))
  const [isChanged, setIsChanged] = useState(false) 

  useEffect(() => {
    setMarkedDay(new Date(selectedDay))
  }, [selectedDay])

  const handleDateChange = (newDate: Date) => {
    setMarkedDay(new Date(newDate))
    setIsChanged(true)
  }

  const handleSave = () => {
    onSave(markedDate)
  }

  const handleClose = () => {
    close()
  }

  const isDateDisabled = (date: CalendarTileProperties) => {
    return !availableDates.some((day) => moment(day.date).format('YYYY-MM-DD') === moment(date.date).format('YYYY-MM-DD'))
  }

  return (
    <Modal isHidden={ !visible } onOverlayClick={ close } >
      <StyledSection>
        <section>
         <Calendar
          onChange={ handleDateChange }
          minDate={ moment().toDate() }
          value={ markedDate }
          tileDisabled={ isDateDisabled }
        />
        </section>
        <footer>
          <Button
            title={ LiteralsService.get('save') }
            onPress={ handleSave }
            isDisabled={ !isChanged }
            filled
            upper
          />
          <Button
            title={ LiteralsService.get('close') }
            onPress={ handleClose }
            upper
          />
        </footer>
      </StyledSection>
    </Modal>
  )
}
